import axios from "axios";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

//Dashboard Count
export async function dashboardcount() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/dashboard-count`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Multi Role view detail
export async function multirolesdetails(role, id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/roles/viewdetails/${role}/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Roles List master
export async function rolemasterlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mrole/list-Mrole`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Roles View master
export async function roledetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mrole/view/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Roles master
export async function rolevalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mrole/validate/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Roles Add master
export async function rolecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mrole/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Roles Update master
export async function roleupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mrole/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Roles Status master
export async function rolestatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mrole/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Blood Group List master
export async function bloodgrouplist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mbloodgroup/list-mblood`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Blood Group Status master
export async function bloodgroupstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mbloodgroup/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Blood Group master
export async function bloodgroupvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mbloodgroup/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Blood Group Create master
export async function bloodgroupcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mbloodgroup/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Blood Group Update master
export async function bloodgroupupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mbloodgroup/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Blood Group View master
export async function bloodgroupdetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mbloodgroup/view/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate School master
export async function schoolvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mschool/validate`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Add master
export async function schoolcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mschool/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Update master
export async function schoolupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mschool/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Status master
export async function schoolstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mschool/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School View master
export async function schooldetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mschool/viewMSchool/${data}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School List master
export async function schoollist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mschool/Mlist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School active List master
export async function schoolactivelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mschool/Mschool-list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Class master
export async function classvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mclass/validate`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Class Add master
export async function classcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mclass/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Class Update master
export async function classupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mclass/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Class Status master
export async function classstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mclass/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Class View master
export async function classdetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mclass/viewclass/${data}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Class List master
export async function classlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mclass/list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Section Add master
export async function sectioncreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/msection/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Section Update master
export async function sectionupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/msection/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Section Status master
export async function sectionstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/msection/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Section View master
export async function sectiondetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/msection/viewsection/${data}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Section List master
export async function sectionlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/msection/list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Tournament type master
export async function tourtypevalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournamenttype/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type Add master
export async function tourtypecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournamenttype/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type list
export async function tourtypelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournamenttype/list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type active list
export async function tourtypeactivelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournamenttype/meettype-list`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type view master
export async function tourtypedetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournamenttype/view/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type Update master
export async function tourtypeupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournamenttype/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament type Status master
export async function tourtypestatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournamenttype/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category active list
export async function agecatactivelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/agecategory/age-list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Age Category Profile edit active list
export async function profileagecatlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/agecategory/age-list-new`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category list master
export async function touragecategorylist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/agecategory/list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Age Category master
export async function agecategoryvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/agecategory/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category Create master
export async function agecategorycreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/agecategory/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category Update master
export async function agecategoryupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/agecategory/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category Status master
export async function agecategorystatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/agecategory/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age Category View master
export async function agecategorydetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/agecategory/view/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Rejected Reason list master
export async function rejectedreasonlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/rejectedreason/list-rejected`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Rejected Reason Create master
export async function rejectedreasoncreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/rejectedreason/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Rejected Reason Update master
export async function rejectedreasonupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/rejectedreason/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Rejected Reason Status master
export async function rejectedreasonstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/rejectedreason/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Rejected Reason View master
export async function rejectedreasondetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/rejectedreason/viewreject/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate State master
export async function statevalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mstate/validate/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//State Add master
export async function statecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mstate/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//State Update master
export async function stateupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mstate/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//State View master
export async function statedetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mstate/view/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//State delete/status master
export async function statestatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mstate/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//State list master
export async function statemasterlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mstate/list-state`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate DIstrict master
export async function districtvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mdistrict/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//District Add master
export async function districtcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mdistrict/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//District Update master
export async function districtupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mdistrict/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//District View master
export async function districtdetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mdistrict/view/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//District delete/status master
export async function districtstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/Mdistrict/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//District list master
export async function districtmasterlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Mdistrict/list-district`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate City master
export async function cityvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mcity/validate`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//City Add master
export async function citycreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mcity/create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//City Update master
export async function cityupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mcity/update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//City View master
export async function citydetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mcity/viewcity/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//City delete/status master
export async function citystatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/mcity/delete`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//City list master
export async function citymasterlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/mcity/list-city`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Validate Sports master
export async function sportsvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/sportscategory/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport  Add master
export async function sporttypecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/sportscategory/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport Update master
export async function sporttypeupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/sportscategory/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport View master
export async function sporttypedetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/sportscategory/view/${data}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport delete/status master
export async function sporttypestatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/sportscategory/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport list master
export async function sporttypelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/sportscategory/sportstypelist`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sports active list
export async function sportsactivelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/sportscategory/sports-category-list`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sports typewise list
export async function schooltypebasedlist(name) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/view-mschool-type/${name}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport category position Add master
export async function sportposcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/sportscategoryposition/create-categoryposition`,
        data,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport category position Update master
export async function sportposupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/sportscategoryposition/update-categoryposition`,
        data,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport category position Status master
export async function sportposstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/sportscategoryposition/delete-categoryposition`,
        data,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport category position View master
export async function sportposdetails(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/sportscategoryposition/view-categoryposition/${data}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Sport category position List master
export async function sportposlist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/sportscategoryposition/list-categoryposition`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Email Keyword List master
export async function emailtempmasterlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/keywordslist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Template List master
export async function templateemaillist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/templatelist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Email Template master
export async function emailtemplatecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/map-keywords-template`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events List master
export async function eventsmasterlist() {
  try {
    return await axios
      .get(`${baseUrl}/Athleteevents/list-athleteevents`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events View master
export async function eventsdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/Athleteevents/view/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events Add master
export async function eventscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/Athleteevents/create`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events Validate master
export async function eventsvalidate(data) {
  try {
    return await axios
      .get(`${baseUrl}/Athleteevents/validate/${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events Update master
export async function eventsupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/Athleteevents/update`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Events Status master
export async function eventstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/Athleteevents/delete`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Similar Player list
export async function similarplayerlist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/duplicatedetails/${data}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Merged or not Player list
export async function mergerornotplayer(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/already_merged_ornot/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Similar Merge Player
export async function similarmergeplayer(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/merge-users`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Similar UnMerge Player
export async function similarunmergeplayer(id, sid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/unmerge-users/${id}/${sid}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Player participated in tournament
export async function tourparticipatedplayerlist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/tournamentlist/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Send Payment Link to Player
export async function sendpaymentlink(tid, id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/send-meet-paymentlink/${tid}/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Change Payment Status
export async function changetourpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/tournament-payment-status`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Change Refund Payment Status
export async function changerefundpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/tournament-entries-refunded-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Change Refund Payment Status
export async function athleticschangerefundpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/athletics-entrysent-refunded-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//View Player
export async function viewprofile(data, yr) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/athlete-details/${data}/${yr}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function viewprofilepassword(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/get-user-password/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//View PErsonal Timings
export async function viewpersonaltimingapi(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/peronal-timings-data-by-sports`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Delete Assessment Files in Profile Page
export async function deletefileinprofile(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/delete-other-files`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Add Player
export async function adminaddplayer(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/players/add-player`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update Player
export async function adminupdateplayer(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/update/player`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update Referee
export async function adminupdatereferee(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-referee`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function adminupdateschoolhead(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-schooladmin`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Player Delete
export async function playerdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-users`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//All Player list
export async function allplayerlist(st, rid, page, per_page, filters) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    let url = `${baseUrl}/superadmin/approval-list?status=${st}&role_id=${rid}&page=${page}&per_page=${per_page}`;
    if (filters.username) url += `&username=${filters.username}`;
    if (filters.full_name) url += `&full_name=${filters.full_name}`;
    if (filters.gender) url += `&gender=${filters.gender}`;
    if (filters.dob_year) url += `&dob_year=${filters.dob_year}`;
    if (filters.mobile) url += `&mobile=${filters.mobile}`;
    if (filters.email) url += `&email=${filters.email}`;
    if (filters.school_ids) url += `&school_ids=${filters.school_ids}`;
    if (filters.school_funder)
      url += `&school_funder=${encodeURIComponent(filters.school_funder)}`;
    return await axios
      .get(url, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Reason list for players
export async function reasonlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/reject-reasons-list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function blocked(uid, ures, urem) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/blocked?user_id=${uid}&reasonsid=${ures}&remarks=${urem}`,

        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function unblocked(uid, ures, urem) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/unblock?user_id=${uid}&reasonsid=${ures}&remarks=${urem}`,

        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Offline Tournament Entry
export async function offlineentryupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/importofflineentries`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Athletics Offline Tournament Entry
export async function athleticsofflineentryupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/importathleticsofflineentries`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Offline Tournament Entry List
export async function offlineentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/offline-entries-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Athletics Offline Tournament Entry List
export async function athleticsofflineentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/offline-athletics-entries-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Send Registeration Tournament Entry
export async function registerentryupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/importsendregistrationlinkexcel`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Send Registeration Tournament Entry List
export async function registerentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/send-reg-link-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Player mapped into LMP
export async function playermappedintotour(id) {
  try {
    return await axios
      .get(`${baseUrl}/is_mapped_log_list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament Code Count Api
export async function tourcodecount() {
  try {
    return await axios
      .get(`${baseUrl}/tournament-max-count`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Validate tournament
export async function Validatetouradd(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/meet-duplicate-exist`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add tournament
export async function touradd(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournament/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update tournament
export async function tourupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournament/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Age Categories to tournament
export async function touraddagecategory(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournament/create-agecategory`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Athletics Age Categories to tournament
export async function athleticsaddagecategory(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-agecate-events`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//List tournament
export async function tourlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Hide/Unhide tournament / events
export async function hidetourlist(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/tournament-display-status`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//View tournament Superadmin
export async function tourviewdetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/view-details/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Delete tournament
export async function tourdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/delete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Class for tournament
export async function tourclassstdlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/view-class-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Age Category tournament
export async function touragecategory(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/category-list-each-tour/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Delete Class for tournament
export async function tourclassdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/delete-meet-stds/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Class for tournament
export async function tourstandardclassadd(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-std-meet-update`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Category for tournament
export async function tourcategorybasedteam(data) {
  try {
    return await axios
      .post(`${baseUrl}/create-team-category`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update Category for tournament
export async function tourcategorydetailbasedteam(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-team-category`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Category Detail for tournament
export async function tourcategorydetail(data) {
  try {
    return await axios
      .post(`${baseUrl}/view-team-category`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Category List for tournament
export async function tourcategorylist(data) {
  try {
    return await axios
      .post(`${baseUrl}/team-category-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament based Class selection dropdown list
export async function tourcategorymapped(data) {
  try {
    return await axios
      .post(`${baseUrl}/team-category-mapped-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Delete Category for tournament
export async function tourcategorydelete(id) {
  try {
    return await axios
      .post(`${baseUrl}/delete-team-category`, id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Delete Category Standard for tournament
export async function tourcategorymappeddelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-team-category-mapped`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//CRM Assign  to Tournament
export async function tourassigncrm(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/tournament/cityadmin-assign-for-meet`,
        data,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//CRM Assign list to Tournament
export async function tourassigncrmlist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/tournament/meet-mapped-cityadmin-list/${id}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Assign  to Tournament
export async function tourassignschool(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/add-new-school-to-tournament`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//CRM Assign Delete to Tournament
export async function tourassigncrmdeletelist(id, rid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/tournament/meet-cityadmin-delete/${id}/${rid}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Assign Delete to Tournament
export async function tourassignschooldeletelist(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-school-to-tournament`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Referee Assign  to Tournament
export async function tourassignreferee(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/tournament/assign-refree-meet`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Referee Assign list to Tournament
export async function tourassignrefereelist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/meet-referee-list/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Referee Assign Delete to Tournament
export async function tourassignrefdeletelist(id, rid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/tournament/meet-referee-delete/${id}/${rid}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament entry list
export async function tourentrylist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/tournament_entries/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics inter tournament entry list
export async function athleticsintertourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/inter-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics intra tournament entry list
export async function athleticsintratourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/intra-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Create based on tournament
export async function teamcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/create-team`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Update based on tournament
export async function teamupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/edit-team`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team View based on tournament
export async function teamdetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/view-team-details/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Delete based on tournament
export async function teamdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/delete-team/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament team list
export async function tourteamlist(id, tid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/teamlist/${id}/${tid}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament team list
export async function tourteamplayerlist(id, tid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/tournament/team-player-list/${id}/${tid}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Player Create for Tournament
export async function teamplayercreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/add-players-to-team`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Player List for Tournament
export async function teamplayerlist(data, tid, cid, eid, sid, sear) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/search-player-list?tournament_meet_id=${data}&team_id=${tid}&class_id=${cid}&category_id=${eid}&school_id=${sid}&usernamesearch=${sear}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Team Player List for Racquet Sports Tournament
export async function racquetteamplayerlist(data, tid, cid, eid, sid, sear, group) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/search-player-list-for-racquet-sports?tournament_meet_id=${data}&team_id=${tid}&class_id=${cid}&category_id=${eid}&school_id=${sid}&usernamesearch=${sear}&group_type=${group}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Team Player Delete for Tournament
export async function teamplayerdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/remove-team-player/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament result list
export async function tourresultlist(id, cid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/tournament/results-upload-list/${id}/${cid}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Winner List tournament
export async function winnerplayerlist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/winners/winnerslist/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Winner List Category wise tournament
export async function winnercategoryplayerlist(id, cid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/winners/winnerslistbycategory/${id}/${cid}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Winner List Category wise tournament
export async function winnercategorydelete(id, cid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/delete-results/${id}/${cid}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Photos Add tournament
export async function photoscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/tournamentimage`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Photos Add External tournament
export async function exteventphotoscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/other-tournament-event-image-upload`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Photos List tournament
export async function photoslist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/tournamentimagelist/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//External Photos List tournament
export async function exteventphotoslist(id, type) {
  try {

    return await axios
      .get(`${baseUrl}/other-tournament-event-list/${id}/${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Photos Delete tournament
export async function photosdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/delete_uploadimage/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Photos Delete External tournament
export async function exteventphotosdelete(id) {
  try {

    return await axios
      .get(`${baseUrl}/other-tournament-event-image-delete/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Gallery Photos List tournament
export async function tourphotoslist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/tournamentuploadimagelist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights Add tournament
export async function highlightscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-meet-highlight-links`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights Update tournament
export async function highlightsupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-meet-highlight-links`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Highlights List tournament
export async function highlightslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/meet-highlightlinks-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights View tournament
export async function highlightsdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/view-highlights-link/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights View tournament
export async function highlightsdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/delete-highlights-link/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//CRM Update
export async function citymanagerupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/cityadminupdate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Head Create
export async function multiplerolescreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/superadmin/roles/create-users-For-roles`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Multi Role Email Validate
export async function multiroleemailvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/roles/validate-roleusers-email/${data}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Head List
export async function multipleroleslist(role, id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/roles/users-list/${role}/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Coach Create
export async function coachrolescreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/create-coaches-for-roles`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//CRM Active List
export async function crmactivelist(role, id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/roles/users-list/${role}/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Multi User Status API
export async function multirolesstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/user-active-inactive`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Base Upload
export async function basedataimport(data) {
  try {
    return await axios
      .post(`${baseUrl}/basedata/importbasedata`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result Upload
export async function resultdataupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/importresults`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result Upload log
export async function resultuploadloglist(id) {
  try {
    return await axios
      .get(`${baseUrl}/result-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Create for tournament
export async function poolcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/pool/create-pool`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Update for tournament
export async function poolupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/pool/edit-pool-name`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool List for tournament
export async function poollisttour(id, eid) {
  try {
    return await axios
      .get(`${baseUrl}/pool/poollist/${id}/${eid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool View for tournament
export async function pooldetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/pool/view-pool-details/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Delete for tournament
export async function pooldelete(id, tid) {
  try {
    return await axios
      .get(`${baseUrl}/pool/delete-pool/${id}/${tid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool List for tournament
export async function poolteamlist(id, eid) {
  try {
    return await axios
      .get(`${baseUrl}/pool/teamlist-of-meet/${id}/${eid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Team Create for tournament
export async function poolautoteamcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/pool/assign-auto-teams-pool`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Team Create for tournament
export async function poolteamcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/pool/add-teams-pool`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Team List for tournament
export async function pooladdedteamlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/pool/teamsofpoollist/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Team Delete for tournament
export async function poolteamdelete(id, tid) {
  try {
    return await axios
      .get(`${baseUrl}/pool/remove-team-pool/${id}/${tid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Import Fixture/Schedule Create for category wise tournament
export async function poolimportfixtures(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-fixtures-for-pool`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Import Fixture/Schedule excel list for category wise tournament
export async function poolimportfixturesexcellist(data) {
  try {
    return await axios
      .post(`${baseUrl}/fixtures-uploaded-excels`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Schedule Create for tournament
export async function schedulecreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/create`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Schedule List for tournament
export async function schedulelist(id, eid) {
  try {
    return await axios
      .get(
        `${baseUrl}/schedule/schedule-list?tournament_id=${id}&category_id=${eid}`
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Schedule Delete for tournament
export async function scheduledelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/delete-schedule`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Schedule Fixture Delete for tournament by poolwise
export async function fixturedeletepoolwise(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/delete-pool-wise-schedule`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Date and Time in Schedule Fixture for tournament
export async function scheduledateandtime(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/add-match-date-time`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Winner and Score in Schedule Fixture for tournament
export async function schedulewinner(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/add-match-winner-score`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Player Statistics in Schedule Fixture for tournament
export async function scheduleplayerstatistics(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/tour-player-level-status-add`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Get Player Statistics in Schedule Fixture for tournament
export async function getplayerstatistics(id, cid, pid, tid, mid) {
  try {
    return await axios
      .get(`${baseUrl}/schedule/tour-player-level-status-details?tournament_id=${id}&category_id=${cid}&pool_id=${pid}&team_id=${tid}&match_id=${mid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Add Sets in Schedule Fixture for volleyball tournament
export async function schedulesetpoints(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/add-set-points-score`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Quarfinal teams list for tournament
export async function schedulequarfinallist(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/teams-list-qsfinals`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Quarfinal teams add for tournament
export async function schedulequarfinalcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/add-teams-next-round`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Check Next round
export async function schedulenextroundlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/check-next-round-match-status`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Quarfinal list for tournament
export async function schedulequarselectedlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/schedule/qsfinals-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//No Knockout teams add for tournament
export async function schedulenoknockoutcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/save-no-knockouts`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//No Knockout list for tournament
export async function schedulenoknocklist(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-no-knockouts`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//No Knockout delete for tournament
export async function schedulenoknockdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-no-knockouts`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Semi finals and finals delete for tournament
export async function semifinalsentriesdelete(id, uid) {
  try {
    return await axios
      .get(`${baseUrl}/delete-rounds?tableid=${id}&admin_id=${uid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Email Templates
export async function emailtemplates(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-communication-template`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Email Templates details
export async function emailtemplatesdetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/templateinfo/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Email Templates Keyword list
export async function emailkeywordlist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/templates-keylist/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//WhatsApp Templates details
export async function wapptemplatesdetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/whatsapptemplateinfo/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//WhatsApp Templates
export async function wapptemplates(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-whatsapp-template`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Payment List
export async function paymentlistadmin() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Tournamentpayment/list-payment`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function paymentdetailadmin(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/Tournamentpayment/view-payment/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Pool Import for tournament
export async function tourpoolimport(data) {
  try {
    return await axios
      .post(`${baseUrl}/upload-pool-excel`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Certificate Import for tournament
export async function touruploadcertificate(data) {
  try {
    return await axios
      .post(`${baseUrl}/certificates/import-certificates`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Certificate log list
export async function tourcertificateloglist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/certificate-entries-excel-log/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Certificate list
export async function tourcertificatelist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/certificates/certificate_list/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Individual Generate Certificate
export async function generatecertificate(id, cid, type, uid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/certificates/generate-individual-certificate?tournament_id=${id}&certificate_uid=${cid}&generate_type=${type}&admin_id=${uid}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Individual Delete Certificate
export async function deletecertificate(id, aid) {
  try {
    return await axios
      .get(`${baseUrl}/certificates/delete-ind-certificate/${id}/${aid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Bulk Generate Certificate
export async function bulkgeneratecertificate(id, uid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/certificates/generate-bulk-certificate?tournament_id=${id}&admin_id=${uid}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tracking list
export async function trackingadminlist(start, end, rid, uid) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/view-track-activity-log?start_date=${start}&end_date=${end}&role_id=${rid}&user_id=${uid}`,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment Create
export async function assessmentcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/saveassessmentlog`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment list
export async function assessmentlist() {
  try {
    return await axios
      .get(`${baseUrl}/assessmentuploadlist`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Datacube
export async function datacubefilter(data) {
  try {
    return await axios
      .post(`${baseUrl}/datacube/datacube-filter`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Datacube Highest Level Played List
export async function highestlevelplayedlist() {
  try {
    return await axios
      .get(`${baseUrl}/datacube-meettypes`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Upload Entry
export async function pointsentryupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/tournament-points-table`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Upload Entry list
export async function pointsuploadlist(id, cid, pid) {
  try {
    return await axios
      .get(`${baseUrl}/tournament-excel-upload-view/${id}/${cid}/${pid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Upload Entry list
export async function tourpointslist(id, cid, pid) {
  try {
    return await axios
      .get(`${baseUrl}/tournament-points-table-view/${id}/${cid}/${pid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Update
export async function pointsupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-tournament-points-table`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Delete
export async function pointsdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-tournament-points-table`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Points Whole Delete
export async function pointswholedelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-points-table`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment Name with Date
export async function assessmentheading(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-update-assessment-dates`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment Name with Date
export async function assessmentdatelist() {
  try {
    return await axios
      .get(`${baseUrl}/assessment-dates`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria , Player & Photo edit
export async function gettokenfromapi(data) {
  try {
    return await axios
      .post(`${baseUrl}/generate-token-for-assessment`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment Name with Date
export async function assessmentdatedetail(data) {
  try {
    return await axios
      .post(`${baseUrl}/view-assessment-date`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment pull request with Date
export async function assessmentpullrequest(data) {
  try {
    return await axios
      .post(`${baseUrl}/insert-assessment-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment group list
export async function assessmentgrouplist(id) {
  try {
    return await axios
      .get(`${baseUrl}/assessment-groups?date_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Assessment player details list
export async function assessmentplayerlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/assessment-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Average List
export async function averagelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/page-total-time-track`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Analytics Data Tournament
export async function analyticslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/total-analytics-count?meet_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner File Upload Save
export async function bannersave(data) {
  try {
    const header = {
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/banner-page-add`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner list
export async function allbannerlist() {
  try {
    return await axios
      .get(`${baseUrl}/bannerlist`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner view
export async function bannerview(data) {
  try {
    return await axios
      .get(`${baseUrl}/bannerdetails/${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner File Upload Edit
export async function banneredit(data) {
  try {
    const header = {
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/banner-page-update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner Role Delete in Edit Page

export async function roledelete(data) {
  try {
    return await axios
      .get(`${baseUrl}/banner_role_delete/${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner List Delete
export async function bannerlistdelete(data) {
  try {
    return await axios
      .get(`${baseUrl}/banner_delete/${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements upload List
export async function achieveuploadlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/achievements-uploaded-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements List
export async function achievelist(id) {
  try {
    return await axios
      .get(`${baseUrl}/achievement-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Upload
export async function achieveupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/achievements-upload`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Individual Upload
export async function achieveindupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-achievements-individualy`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Player search
export async function achieveplayersearch(data, sid) {
  try {
    return await axios
      .get(
        `${baseUrl}/search-user-achievements?search=${data}&school_id=${sid}`
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Achievements Player Update
export async function achieveplayerupdate(id, user, admin) {
  try {
    return await axios
      .get(
        `${baseUrl}/achievement-map-with-username?table_id=${id}&user_id=${user}&admin_id=${admin}`
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Edit Player
export async function achieveplayerview(id) {
  try {
    return await axios
      .get(`${baseUrl}/achievements-view/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Update Player
export async function achieveupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/achievements-edit`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievements Player delete
export async function achieveplayerdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/delete-achievement/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School team upload
export async function schoolteamupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/user-selected-team`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School team list
export async function schoolteamlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/selected-school-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age category active list
export async function agecategoryaclivelist() {
  try {
    return await axios
      .get(`${baseUrl}/agecat-isactive-list`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Banner Tracking List
export async function bannerserstrackingadminlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/banners-tracking-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type List master
export async function eventtypelist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/meventtype/list-eventtype`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Eventtype Status master
export async function eventtypestatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/meventtype/delete`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type Create master
export async function eventtypecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/meventtype/create`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type Validate master
export async function eventtypevalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/meventtype/validate`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type Update master
export async function eventtypeupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/meventtype/update`, data, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type View master
export async function eventtypedetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/meventtype/view/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Event Type Active List
export async function eventtypeactivelist() {
  try {
    return await axios
      .get(`${baseUrl}/list-eventtype-status`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Event List
export async function othereventlist() {
  try {
    return await axios
      .get(`${baseUrl}/otherevent/eventlist`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Event List
export async function othereventdetails(id) {
  try {
    return await axios
      .get(`${baseUrl}/otherevent/event-view-details/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Events Create
export async function othereventcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/otherevent/eventcreate`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Events Create
export async function othereventupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/otherevent/eventupdate`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Events Delete
export async function othereventdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/otherevent/eventdelete/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Other Events Send Register Link
export async function othereventsendregisterlink(data) {
  try {
    return await axios
      .post(`${baseUrl}/send-event-reg-link`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Other Event Refund
export async function othereventrefundpayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/event-entries-refunded-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Other event refund list
export async function othereventrefundlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/event-entries-refunded-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament entry list
export async function tourrefundlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/tournament-entries-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics tournament refund list
export async function athletictourrefundlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/athletic-entries-refunded-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//tournament entry list
export async function eventplayerentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/other-event-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria List master
export async function perfcriterialist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/mperformancecriteria/list-performancecriteria`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Status master
export async function perfcriteriastatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancecriteria/deleteperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Create master
export async function perfcriteriacreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancecriteria/createperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Validate master
export async function perfcriteriavalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancecriteria/validateperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Update master
export async function perfcriteriaupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancecriteria/updateperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria View master
export async function perfcriteriadetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/mperformancecriteria/view-performancecriteria/${id}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria List based on sports
export async function perfcriteriasportslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/list-performance-criteriasports/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Performance Tracking List master
export async function perftrackinglist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/mperformancetracking/list-performancecriteria`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Performance Tracking Status master
export async function perftrackingstatus(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancetracking/deleteperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Tracking Create master
export async function perftrackingcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancetracking/createperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Tracking Validate master
export async function perftrackingvalidate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancetracking/validateperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Tracking Update master
export async function perftrackingupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/superadmin/mperformancetracking/updateperformancecriteria`,
        data,
        {
          headers: header,
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Tracking View master
export async function perftrackingdetails(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(
        `${baseUrl}/superadmin/mperformancetracking/view-performancecriteria/${id}`,
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Tracking List based on sports
export async function perftrackingsportslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/list-performance-tracking-sports/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Performance Criteria List based on sports
export async function tourcategorybasedplayerlist(id, cid) {
  try {
    return await axios
      .get(`${baseUrl}/all-player-list-tournament/${id}/${cid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Count List
export async function perfcriteriacountlist(id, cid) {
  try {
    return await axios
      .get(`${baseUrl}/list-performance-player-photo-count/${id}/${cid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria Add
export async function perfcriteriaplayerphotocreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/create-performance-player-photo`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Photo Update
export async function perfcriteriaphotoupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-performance-photo`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Player Update
export async function perfcriteriaplayerupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-performance-player`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Player Delete
export async function perfcriteriaplayerdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-performance-player`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Photo Delete
export async function perfcriteriaphotodelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-performance-photo`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Performance Criteria , Player & Photo edit
export async function perfcriteriaplayerphotoedit(id, cid) {
  try {
    return await axios
      .get(`${baseUrl}/list-performance-player-photo/${id}/${cid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Send Payment Link to Player from Other events
export async function othereventsendpaymentlink(tid, id) {
  try {
    return await axios
      .get(`${baseUrl}/event_send_paymentlink/${tid}/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//School Discount Percentage
export async function schooldiscountcreateupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-discount-percentage`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//School Statement
export async function schoolstatementcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-school-statement`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Statement
export async function schoolstatementupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-school-statement`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Statement
export async function schoolstatementview(id, did) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-school-statement?school_id=${id}&school_or_funder=${did}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament & Event List
export async function toureventlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/tournament-event-list?school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Tournament & Event List
export async function medalslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/achievements-summary`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Sports Represented List
export async function sportsreplist(id, fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/sports-reprecented?school_funder_group_id=${id}&school_or_funder_or_group=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Play Session
export async function playsessioncreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-play-sessions`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Play Session
export async function playsessionupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-play-sessions`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Play Session
export async function playsessionview(id, type) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-play-sessions?school_id=${id}&school_or_funder=${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Success Stories
export async function storycreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-success-stories`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Success Stories
export async function storyupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-success-stories`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Success Stories
export async function storyview(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-success-stories?article_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Success Stories
export async function storylist(id, type) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-success-stories?school_id=${id}&school_or_funder=${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Success Stories
export async function storydelete(id, aid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/delete-success-stories?admin_id=${id}&article_id=${aid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Gallery
export async function cmsgallerylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/gallery-list?school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Resources
export async function cmsresourcelist(id, data, st) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-resources?school_id=${id}&tags_search=${data}&school_or_funder=${st}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//All Resources
export async function allcmsresourcelist(sdate, edate, tid, id, fid, type) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-over-all-resources-success-stories?start_date=${sdate}&end_date=${edate}&tags_id=${tid}&schools_id=${id}&funder_id=${fid}&file_type=${type}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Resources
export async function coachcmsresourcelist(id, data, st) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-resources-coach?school_id=${id}&tags_search=${data}&school_or_funder=${st}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Resources
export async function cmsresourcecreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-resources`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Resources - Update thumbnail
export async function cmsresourcethumbnail(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-resources-thumbnail`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Vendors List
export async function vendorlist() {
  try {
    return await axios
      .get(`${baseUrl}/products/list-vendors`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Vendors Add
export async function vendorcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/products/create-vendors`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Vendors Update
export async function vendorupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/products/update-vendors`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Vendors Details
export async function vendordetail(vid) {
  try {
    return await axios
      .get(`${baseUrl}/products/view-vendors?vendor_id=${vid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Vendors Status
export async function vendorpublish(aid, vid, pid) {
  try {
    return await axios
      .get(`${baseUrl}/products/change-publish-status-vendors?admin_id=${aid}&vendor_id=${vid}&published_or_not=${pid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Product List
export async function productlist() {
  try {
    return await axios
      .get(`${baseUrl}/products/list-products`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Product Add
export async function productcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/products/create-products`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Product Update
export async function productupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/products/update-products`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Product Details
export async function productdetail(vid) {
  try {
    return await axios
      .get(`${baseUrl}/products/view-products?product_ins_id=${vid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Product Delete
export async function productdelete(aid, vid) {
  try {
    return await axios
      .get(`${baseUrl}/products/delete-products?admin_id=${aid}&product_ins_id=${vid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Webpage Product List
export async function webpageproductlist(id, sid) {
  try {
    return await axios
      .get(`${baseUrl}/products/list-mapped-webpages?product_unique_id=${id}&school_funder_group=${sid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Webpage Product List
export async function webpagemappedremove(id) {
  try {
    return await axios
      .get(`${baseUrl}/products/remove-mapped-webpages?mapped_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Webpage Product List
export async function webpagenewproduct(data) {
  try {
    return await axios
      .post(`${baseUrl}/products/add-new-webpages`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Webpage Status in product List
export async function webpageproductstatus(id, sid, stat) {
  try {
    return await axios
      .get(`${baseUrl}/products/change-mapped-status?product_unique_id=${id}&school_funder_group=${sid}&display_status=${stat}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Resouces
export async function cmsresourcedelete(uid, id, did) {
  try {
    return await axios
      .get(`${baseUrl}/cms/delete-resources?admin_id=${uid}&resources_id=${id}&deleted_by=${did}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Resources
export async function cmsselectresource(data) {
  try {
    return await axios
      .get(`${baseUrl}/cms/select-resources?${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Medal 
export async function fundermedalslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/funder-schools-achievements-summary`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Funder and Manager Statistics 
export async function statisticslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/funder-schools-achievements-summary-playerwise`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Funder Graphs 
export async function fundergraphlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/funder-schools-achievements-summary-graph`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Medal Degails
export async function medalsdetaillist(fid, stst) {
  try {
    return await axios
      .get(`${baseUrl}/cms/get-achievements-based-on-funder?school_funder_group_id=${fid}&school_funder_group=${stst}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//IIM Medal Details
export async function iimdetaillist(fid) {
  try {
    return await axios
      .get(`${baseUrl}/iim-players-list/${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School,Funder and Group of School List 
export async function schoolmanagerlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/manager/all-schools-funder-group-list?manager_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School,Funder and Group of School Add 
export async function schoolmanagercreate(id, mid, sid, aid) {
  try {
    return await axios
      .get(`${baseUrl}/manager/add-school-funder-group-to-manager?manager_id=${id}&add_school_type=${mid}&school_funder_group_id=${sid}&admin_id=${aid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//School,Funder and Group of School Add 
export async function schoolmanagerdelete(id, mid, sid) {
  try {
    return await axios
      .get(`${baseUrl}/manager/remove-school-funder-group-to-manager?manager_id=${id}&delete_school_type=${mid}&school_funder_group_id=${sid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Webpage Tracking List
export async function webpagetrackinglist(data) {
  try {
    return await axios
      .post(`${baseUrl}/webpage-user-info-tracking-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Webpage Tracking List
export async function adminplayerstatistics(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/all-players-achievements-summary`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Coach profile create
export async function cmsfundercoachcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-coach-profiles`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Coach profile update
export async function cmsfundercoachupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-coach-profiles`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Coach profile list
export async function cmsfundercoachlist(id, fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-coach-profiles?school_funder_group_id=${id}&school_or_funder_or_group=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Coach profile view
export async function cmsfundercoachdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-coach-profiles?profile_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Coach profile delete
export async function cmsfundercoachdelete(id, fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/delete-coach-profiles?admin_id=${id}&profile_id=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Testimonials List
export async function cmsfundermoniallist(id, fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/list-testimonials?school_funder_group_id=${id}&school_or_funder_or_group=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonial Create
export async function cmsfundermonialcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/create-testimonials`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonial Update
export async function cmsfundermonialupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/cms/update-testimonials`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonial view
export async function cmsfundermonialdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/cms/view-testimonials?testimonial_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Testimonial delete
export async function cmsfundermonialdelete(id, fid) {
  try {
    return await axios
      .get(`${baseUrl}/cms/delete-testimonials?admin_id=${id}&testimonial_id=${fid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Highlights Add Events
export async function eventhighlightscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-otherevent-highlight-links`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights Update Events
export async function eventhighlightsupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-otherevent-highlight-links`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Highlights List Events
export async function eventhighlightslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/otherevent-highlightlinks-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights View Events
export async function eventhighlightsdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/view-otherevent-highlights-link/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Highlights View Events
export async function eventhighlightsdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/delete-otherevent-highlights-link/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Highlights View Events
export async function productstrackinglist(id, fdate, tdate, pid) {
  try {
    // console.log(`${baseUrl}/products/list-click-tracking?school_funder_group=${id}&from_date=${fdate}&to_date=${tdate}&product_id=${pid}`)
    return await axios
      .get(`${baseUrl}/products/list-click-tracking?school_funder_group=${id}&from_date=${fdate}&to_date=${tdate}&product_id=${pid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function datecountlist(fdate, tdate) {
  try {
    return await axios
      .get(`${baseUrl}/register-student-list?start_date=${fdate}&end_date=${tdate}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Achievement Tournament List
export async function achtourlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/list-achievement-tournament-by-admin?school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Photos Add for Achievement tournament
export async function achtourphotoscreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/achievement-tournament-image-upload`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Photos List for Achievement tournament
export async function achtourphotoslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/achievement-tournament-image-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Photos Delete for Achievement tournament
export async function achtourphotosdelete(id) {
  try {
    return await axios
      .get(`${baseUrl}/achievement-tournament-image-delete/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Achievement tournament
export async function achievementtourwise(data) {
  try {
    return await axios
      .post(`${baseUrl}/achievement-tournament-achievements-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Receipt Approve or Reject
export async function receiptapprej(data) {
  try {
    return await axios
      .post(`${baseUrl}/approve-reject-external-payment-receipt`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Receipt Delete
export async function receiptdelete(rid, tid, id) {
  try {
    return await axios
      .get(`${baseUrl}/delete-receipt-and-entry?receipt_id=${rid}&tournament_meet_id=${tid}&school_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Personal Details Upload - Student Assessment
export async function personaldetupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-personal-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Personal Details Excel Lofg - Student Assessment
export async function personaldetuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/personal-details-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Details Upload - Student Assessment
export async function schooldetupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-school-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//School Details Excel Lofg - Student Assessment
export async function schooldetuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/school-details-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Personal Timings Upload - Student Assessment
export async function personaltimeupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-personal-timings`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Personal Timings Excel Log - Student Assessment
export async function personaltimeuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/personal-timings-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Attendance Upload - Student Assessment
export async function attendancerepupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-attendance-report`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Attendance Excel Log - Student Assessment
export async function attendancerepuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/attendance-report-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Physical Health Upload - Student Assessment
export async function physicalhealthupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-physical-health-data`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Physical Health Excel Log - Student Assessment
export async function physicalhealthuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/physical-health-data-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//physicalogical Upload - Student Assessment
export async function physicalogicalupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-psychological-behavioral-profile`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//physicalogical Excel Log - Student Assessment
export async function physicalogicaluploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/psychological-behavioral-profile-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Physical Assessment Upload - Student Assessment
export async function physicalassupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-physical-assessment`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Physical Assessment Excel Log - Student Assessment
export async function physicalassuploadlog(data) {
  try {
    return await axios
      .post(`${baseUrl}/physical-assessment-excel-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//File Uploads in Player Profile
export async function assessmentfileupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/assessment-file-uploads`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Physical Assessment Data Sports
export async function assessmentgraphsports(data) {
  try {
    return await axios
      .post(`${baseUrl}/physical-assessment-data-by-sports`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


// Class Sports Assessment (Funder) - Baseline / Endline class-wise
export async function classSportsAssessment(data) {
  try {
    return await axios
      .post(`${baseUrl}/class-sports-assessment`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Sports Profile Detail Delete
export async function sportsprofiledetaildelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-sports-profile-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



//Personal Timing Delete
export async function personaltimingdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-personal-timing`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Physical Health Delete
export async function physicalhealthdelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-physical-health-data`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Phychological Behavioural Delete
export async function phychologydelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-psychological-behavioral-profile`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Attendance Delete
export async function attendancedelete(data) {
  try {
    return await axios
      .post(`${baseUrl}/delete-attendance`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Create Form
export async function schformcreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/form-create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update Form
export async function schformupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/form-update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//List Form
export async function schformlist() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/form-list`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Detail Form
export async function schformdetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/form-details/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Delete Form
export async function schformdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/form-delete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}




//Create Competition Type
export async function formcomptypecreate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/competition-type-create`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Update Competition Type
export async function formcomptypeupdate(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/competition-type-update`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//List Competition Type
export async function formcomptypelist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/competition-type-list/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Detail Competition Type
export async function formcomptypedetail(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/competition-type-details/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Delete Competition Type
export async function formcomptypedelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/competition-type-delete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Scholarship Form Register
export async function formregsave(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/scholarship-form-save`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Scholarship Form List
export async function formreglist(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/scholarship-form-list/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Scholarship Form Delete
export async function formregdelete(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/scholarship-form-delete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Scholarship Form Detail
export async function formregdetail(id,did) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/scholarship-form-details/${id}/${did}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Form Mobile Check
export async function formmobilecheck(id,mob) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/scholarship-validate-mobile/${id}/${mob}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Form Email Check
export async function formemailcheck(id,mail) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/scholarship-validate-email/${id}/${mail}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Scholarship Form Register
export async function formuserconvert(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/convert-user`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Form Funder List
export async function formlistfunder(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/form-funders-list/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Form Funder Delete
export async function formdeletefunder(id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/scholarship/form-funder-delete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Funders to Form
export async function addFundersToForm(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/superadmin/scholarship/add-funders-to-form`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}



function catcherror(error) {
  console.log(error.response);
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     window.location.reload();
      //   }
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
